module.exports = __webpack_public_path__ + "static/media/cloud_4.2ae30b82.png";